import {
  LoadedCoopEscola,
  LoadedTipoDocumento,
} from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/listaPrograma/listaPeriodo/listaPeriodoItem/cooperativa/Modal/ModalAddCoop/DocumentCoop/__types';
import { EscolaEditTabs } from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/__enum';
import {
  ARRAY_UTILS_SORT_ASC,
  getOrderedByObjectStringProperty,
} from '../../utils/ArrayUtils';
import { transformNullIntoEmpty } from '../../utils/DataUtils';
import { TOTAL_ITEMS_FOR_PAGE } from '../../utils/PaginationUtils';
import {
  CHANGE_ESCOLA_STATUS_ACTION,
  CHANGED_ESCOLA_EDITING_VALUE_ACTION,
  CHANGED_IDEB_EDITING_VALUE_ACTION,
  CHANGED_PERIODO_EDITING_VALUE_ACTION,
  CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION,
  CHANGED_PERIODO_EDITING_VALUE_JORNADA_ACTION,
  CLEARED_ALL_IDEB_ACTION,
  CLEARED_ESCOLA_ACTION,
  CLEARED_ESCOLAS_PAGE_ACTION,
  CLEARED_IDEB_ACTION,
  CLEARED_PERIODO_ACTION,
  CLEARED_PERIODO_COOP_ACTION,
  CLEARED_PERIODO_JORNADA_ACTION,
  CLOSE_MODAL,
  LOADED_ALL_ESCOLAS_BY_LIST_CIDADE_ID,
  LOADED_ALL_IDEBS_ACTION,
  LOADED_ALL_PERIODOS_ACTION,
  LOADED_ASSESSOR_DATA,
  LOADED_COOPS_ESCOLAR_ACTION,
  LOADED_DADOS_DA_ESCOLA_ACTION,
  LOADED_DADOS_DA_ESCOLA_COOP_ACTION,
  LOADED_DADOS_DA_ESCOLA_JORNADA_ACTION,
  LOADED_ESCOLA_ACTION,
  LOADED_ESCOLAS_ACTION,
  LOADED_ESCOLAS_BY_COOPS_ACTION,
  LOADED_ESCOLAS_PAGE_ACTION,
  LOADED_ESCOLAS_POR_CIDADE_ACTION,
  LOADED_ESCOLAS_POR_CIDADES_COOP_ACTION,
  LOADED_ESCOLAS_POR_ESTADO_CIDADE_ACTION,
  LOADED_ETAPAS_ENSINO_ACTION,
  LOADED_IDEB_ACTION,
  LOADED_MODALIDADES_ACTION,
  LOADED_PERIODO_ACTION,
  LOADED_PERIODO_COOP_ACTION,
  LOADED_PERIODO_JORNADA_ACTION,
  LOADED_PERIODOS_ACTION,
  LOADED_PERIODOS_COOP_ACTION,
  LOADED_PERIODOS_JORNADA_ACTION,
  LOADED_PRINCIPIO_VALOR_ACTION,
  LOADED_PROGRAMA_INFO_ACTION,
  LOADED_PROGRAMAS_ACTION,
  LOADED_TIPO_DOCUMENTO_ACTION,
  LOADING_MODALIDADES_ACTION,
  LOADING_PERIODOS_ACTION,
  LOADING_PERIODOS_COOP_ACTION,
  LOADING_PERIODOS_JORNADA_ACTION,
  LOADING_PROGRAMAS_ACTION,
  OPEN_MODAL,
  REMOVED_PERIODO_ACTION,
  REMOVED_PERIODO_JORNADA_ACTION,
  RESET_PROGRAMA_VALUE,
  RESETED_ESCOLAS,
  SAVING_COOP_ESCOLAR,
  SET_CURRENT_TAB,
  SET_CURRENT_TAB_PROGRAMA,
  SUBMIT_COOP_DATA_FAILURE,
  SUBMIT_COOP_DATA_SUCCESS,
  UPDATE_PROGRAMA_VALUE,
} from '../modules/EscolasActions';
import { AssessorData, EscolasAction, TipoPrograma } from './EscolasTypes';

export const IDEB_AVERAGE_DECIMALS_TOTAL = 1;

const PAGE_LIST_INITIAL_STATE = {
  filtro: '',
  page: -1,
  totalElements: 0,
  totalPages: 0,
  elements: [] as string[],
};

const PAGE_LIST_PERIODOS_INITIAL_STATE = {
  page: 1,
  totalElements: 0,
  totalPages: 0,
  elements: [] as string[],
};

const ESCOLA_EDITING_NOT_NULL_PROPS = [
  'nomeFantasia',
  'razaoSocial',
  'cnpj',
  'telefone',
  'inep',
  'etapasEducacao',
  'email',
  'cep',
  'endereco',
  'numero',
  'complemento',
  'bairro',
  'estado',
  'cidade',
];

const ESCOLA_EDITING_INITIAL_STATE = {
  id: '',
  nomeFantasia: '',
  tipoInstituicao: -1,
  etapasEducacao: [],
  razaoSocial: '',
  cnpj: '',
  telefone: '',
  inep: '',
  email: '',
  coop: -1,
  cep: '',
  endereco: '',
  numero: '',
  complemento: '',
  bairro: '',
  estado: '',
  idEstado: -1,
  cidade: '',
};

const PERIODO_EDITING_NOT_NULL_PROPS = ['cnpj', 'periodo'];

const PERIODO_EDITING_INITIAL_STATE = {
  periodosList: [],
  loadingPeriodosList: true,
  idEscola: '',
  periodo: '',
  edInfantilProf: 0,
  edInfantilAlun: 0,
  ensFundIProf: 0,
  ensFundIAlun: 0,
  ensFundIIProf: 0,
  ensFundIIAlun: 0,
  ensMedioProf: 0,
  ensMedioAlun: 0,
  ejaProf: 0,
  ejaAlun: 0,
  especializadaProf: 0,
  especializadaAlun: 0,
  colaboradores: 0,
  permiteEdicao: false,
  permiteExclusao: false
};

const PERIODO_EDITING_INITIAL_STATE_COOP = {
  periodosList: [],
  loadingPeriodosList: true,
  periodo: '',
  idEscola: '',
  idperiodo: '',
  ensFundIIProf: 0,
  ensFundIIAlun: 0,
  ensMedioProf: 0,
  ensMedioAlun: 0,
  especializadaProf: 0,
  especializadaAlun: 0,
  colaboradores: 0,
  permiteEdicao: false,
  permiteExclusao: false
};

const PERIODO_EDITING_INITIAL_STATE_JORNADA = {
  periodosList: [],
  loadingPeriodosList: true,
  periodo: '',
  idEscola: '',
  idperiodo: '',
  colaboradores: 0,
  ensFundIProf: 0,
  ensFundIAlun: 0,
  ensFundIIProf: 0,
  ensFundIIAlun: 0,
  especializadaProf: 0,
  especializadaAlun: 0,
  permiteEdicao: false,
  permiteExclusao: false
};

const IDEB_EDITING_INITIAL_STATE = {
  cnpj: '',
  ano: '',
  media: '',
  meta: '',
};

const savedAssessorData = localStorage.getItem('assessorPrograma');

const ASSESSOR_DATA_INITIAL_STATE: AssessorData = savedAssessorData
  ? JSON.parse(savedAssessorData)
  : {
    nome: '',
    celular: '',
    email: '',
    cpf: '',
    idEmpresa: null,
    cooperativas: [],
    formacaoAcademica: null,
    qualificacao: '',
    cooperativasGestor: [],
    dataNascimento: '',
    programasEducacionais: [],
  };

const IDEB_EDITING_NOT_NULL_PROPS = ['id', 'media', 'meta', 'ano'];

const INITIAL_STATE = {
  programaTabCurrent: '',
  currentTab: EscolaEditTabs.Informacoes,
  isOpen: false,
  modalContent: null,
  selectedCheckboxes: [] as string[],
  formComponentsVisible: {} as { [key: string]: boolean },
  isCadastroAno: false,
  assessorData: ASSESSOR_DATA_INITIAL_STATE,
  loadingList: false,
  list: [] as string[],
  loadingByCoopsList: false,
  byCoopsList: [] as any[],
  loadingEtapasEnsinoList: false,
  etapasEnsinoList: [] as string[],
  loadingPrincipioValorList: false,
  principioValorList: [] as string[],
  loadingEscolasPorCidade: false,
  escolasPorCidade: [] as string[],
  loadingEscolasPorCooperativaEstadoCidade: false,
  escolasPorCooperativaEstadoCidade: [] as string[],
  loadingEscolasPorCidadesCoop: false,
  escolasPorCidadesCoop: [] as string[],
  pageSize: TOTAL_ITEMS_FOR_PAGE,
  pageList: PAGE_LIST_INITIAL_STATE,
  escolaEditing: ESCOLA_EDITING_INITIAL_STATE,
  dadosDaEscola: [] as any[],
  pagePeriodoEscola: PAGE_LIST_PERIODOS_INITIAL_STATE,
  dadosDaEscolaJornada: [] as any[],
  idebEditing: IDEB_EDITING_INITIAL_STATE,
  periodoEditing: PERIODO_EDITING_INITIAL_STATE,
  periodoEditingCoop: PERIODO_EDITING_INITIAL_STATE_COOP,
  periodoEditingJornada: PERIODO_EDITING_INITIAL_STATE_JORNADA,
  loadingAllPeriodos: false,
  allPeriodos: [] as { nomPeriodo?: string }[],
  loadingAllIdebs: false,
  allIdebs: [] as string[],
  loadingEscolasByCidadesList: false,
  escolasByCidadesList: [] as { nome: string, id: string }[],
  coopData: null,
  error: null,
  modalidades: [] as string[],
  loadingModalidades: false,
  programas: {
    [TipoPrograma.UniaoFazAVida]: {
      checked: false,
      anoImplementacao: '',
      ativo: false,
      disabled: false,
      tipoPrograma: null,
    },
    [TipoPrograma.CooperativaEscolar]: {
      checked: false,
      anoImplementacao: '',
      ativo: false,
      disabled: false,
      tipoPrograma: null,
    },
    [TipoPrograma.JornadaEducacao]: {
      checked: false,
      anoImplementacao: '',
      ativo: false,
      disabled: false,
      tipoPrograma: null,
    },
  },
  loadingProgramas: false,
  coopsEscolar: [] as LoadedCoopEscola[],
  tipoDocumentoCoop: [] as LoadedTipoDocumento[],
  savingCoops: false,
  dataEditCoop: [] as any,
  errorEditCoop: null,
  loadingEditCoop: false,
};
export type State = typeof INITIAL_STATE;

const defaultProgramas = {
  "0": { checked: false, anoImplementacao: '', ativo: false, disabled: false, tipoPrograma: null },
  "1": { checked: false, anoImplementacao: '', ativo: false, disabled: false, tipoPrograma: null },
  "2": { checked: false, anoImplementacao: '', ativo: false, disabled: false, tipoPrograma: null },
};

const getRefreshedPageList = (
  lastPageList: typeof PAGE_LIST_INITIAL_STATE,
  newPageList: typeof PAGE_LIST_INITIAL_STATE
) => {
  return {
    ...lastPageList,
    filtro: newPageList.filtro,
    page: newPageList.page,
    totalElements: newPageList.totalElements,
    totalPages: newPageList.totalPages,
    elements: [...lastPageList.elements, ...newPageList.elements],
  };
};

const getChangedStatusList = (
  pageList: typeof PAGE_LIST_INITIAL_STATE,
  id: string,
  status: string
) => {
  const newPageList = {
    ...pageList,
    elements: [] as string[],
  };
  pageList.elements.forEach((element: any) => {
    if (element.id === id) {
      newPageList.elements.push({
        ...element,
        status,
      });
    } else {
      newPageList.elements.push(element);
    }
  });
  return newPageList;
};

const convertToDouble = (value: string) => {
  return Number(value).toFixed(IDEB_AVERAGE_DECIMALS_TOTAL);
};

const formatLoadedIDEB = (ideb: any) => {
  return {
    ...ideb,
    meta: convertToDouble(ideb.meta),
    media: convertToDouble(ideb.media),
  };
};

export default function EscolasReducer(
  state: State = INITIAL_STATE,
  action: EscolasAction
): State {
  switch (action.type) {
    case RESETED_ESCOLAS:
      return {
        ...INITIAL_STATE,
      };
    case LOADED_DADOS_DA_ESCOLA_ACTION:
    case LOADED_DADOS_DA_ESCOLA_COOP_ACTION:
    case LOADED_DADOS_DA_ESCOLA_JORNADA_ACTION:
      return {
        ...state,
        dadosDaEscola: action.payload.dadosDaEscola,
        pagePeriodoEscola: action.payload.pagePeriodoEscola,
      };

    case LOADED_ESCOLAS_BY_COOPS_ACTION:
      return {
        ...state,
        byCoopsList: getOrderedByObjectStringProperty(
          action.payload as string[],
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_ESCOLAS_ACTION:
      return {
        ...state,
        list: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_ESCOLAS_POR_CIDADE_ACTION:
      return {
        ...state,
        escolasPorCidade: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_ESCOLAS_POR_ESTADO_CIDADE_ACTION:
      return {
        ...state,
        escolasPorCooperativaEstadoCidade: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_ESCOLAS_POR_CIDADES_COOP_ACTION:
      return {
        ...state,
        escolasPorCidadesCoop: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case CHANGE_ESCOLA_STATUS_ACTION:
      return {
        ...state,
        pageList: getChangedStatusList(
          state.pageList,
          action.payload.id,
          action.payload.status
        ),
      };
    case LOADED_ETAPAS_ENSINO_ACTION:
      return { ...state, etapasEnsinoList: action.payload };
    case LOADED_PRINCIPIO_VALOR_ACTION:
      return { ...state, principioValorList: action.payload };
    case LOADED_ESCOLAS_PAGE_ACTION:
      return {
        ...state,
        pageList: getRefreshedPageList(state.pageList, action.payload),
      };
    case CHANGED_PERIODO_EDITING_VALUE_ACTION:
      return {
        ...state,
        periodoEditing: {
          ...state.periodoEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case CHANGED_PERIODO_EDITING_VALUE_COOP_ACTION:
      return {
        ...state,
        periodoEditingCoop: {
          ...state.periodoEditingCoop,
          [action.payload.name]: action.payload.value,
        },
      };
    case CHANGED_PERIODO_EDITING_VALUE_JORNADA_ACTION:
      return {
        ...state,
        periodoEditingJornada: {
          ...state.periodoEditingJornada,
          [action.payload.name]: action.payload.value,
        },
      };
    case CHANGED_IDEB_EDITING_VALUE_ACTION:
      return {
        ...state,
        idebEditing: {
          ...state.idebEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case CLEARED_ALL_IDEB_ACTION:
      return { ...state, allIdebs: [] };
    case CLEARED_PERIODO_ACTION:
      return { ...state, periodoEditing: PERIODO_EDITING_INITIAL_STATE };
    case LOADED_PERIODO_ACTION:
      return {
        ...state,
        periodoEditing: transformNullIntoEmpty(
          {
            ...PERIODO_EDITING_INITIAL_STATE,
            ...action.payload,
          },
          PERIODO_EDITING_NOT_NULL_PROPS
        ),
      };
    case CLEARED_PERIODO_COOP_ACTION:
      return {
        ...state,
        periodoEditingCoop: PERIODO_EDITING_INITIAL_STATE_COOP,
      };
    case CLEARED_PERIODO_JORNADA_ACTION:
      return {
        ...state,
        periodoEditingJornada: PERIODO_EDITING_INITIAL_STATE_JORNADA,
      };
    case LOADED_PERIODO_COOP_ACTION:
      return {
        ...state,
        periodoEditingCoop: transformNullIntoEmpty(
          {
            ...PERIODO_EDITING_INITIAL_STATE_COOP,
            ...action.payload,
          },
          PERIODO_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADED_PERIODO_JORNADA_ACTION:
      return {
        ...state,
        periodoEditingJornada: transformNullIntoEmpty(
          {
            ...PERIODO_EDITING_INITIAL_STATE_JORNADA,
            ...action.payload,
          },
          PERIODO_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADED_ASSESSOR_DATA:
      localStorage.setItem('assessorPrograma', JSON.stringify(action.payload));
      return {
        ...state,
        assessorData: action.payload,
      };
    case CLEARED_ESCOLAS_PAGE_ACTION:
      return { ...state, pageList: PAGE_LIST_INITIAL_STATE };
    case REMOVED_PERIODO_ACTION:
      return {
        ...state,
        dadosDaEscola: state.dadosDaEscola.filter((item) => {
          return item.idEscola === action.payload.idEscola &&
            item.periodo === action.payload.periodo
            ? false
            : true;
        }),
      };
    case REMOVED_PERIODO_JORNADA_ACTION:
      return {
        ...state,
        dadosDaEscolaJornada: state.dadosDaEscolaJornada.filter((item) => {
          return item.idEscola === action.payload.idEscola ? false : true;
        }),
      };
    case LOADING_PERIODOS_ACTION:
      return {
        ...state,
        periodoEditing: {
          ...state.periodoEditing,
          loadingPeriodosList: action.payload,
        },
      };
    case LOADING_PERIODOS_COOP_ACTION:
      return {
        ...state,
        periodoEditingCoop: {
          ...state.periodoEditingCoop,
          loadingPeriodosList: action.payload,
        },
      };
    case LOADING_PERIODOS_JORNADA_ACTION:
      return {
        ...state,
        periodoEditingJornada: {
          ...state.periodoEditingJornada,
          loadingPeriodosList: action.payload,
        },
      };
    case LOADED_PERIODOS_ACTION:
      return {
        ...state,
        periodoEditing: {
          ...state.periodoEditing,
          periodosList: action.payload,
          loadingPeriodosList: false,
        },
      };
    case LOADED_PERIODOS_COOP_ACTION:
      return {
        ...state,
        periodoEditingCoop: {
          ...state.periodoEditingCoop,
          periodosList: action.payload,
          loadingPeriodosList: false,
        },
      };
    case LOADED_PERIODOS_JORNADA_ACTION:
      return {
        ...state,
        periodoEditingJornada: {
          ...state.periodoEditingJornada,
          periodosList: action.payload,
          loadingPeriodosList: false,
        },
      };
    case LOADED_ALL_PERIODOS_ACTION:
      return {
        ...state,
        allPeriodos: action.payload,
      };
    case LOADED_IDEB_ACTION:
      return {
        ...state,
        idebEditing: formatLoadedIDEB(
          transformNullIntoEmpty(
            {
              ...IDEB_EDITING_INITIAL_STATE,
              ...action.payload,
            },
            IDEB_EDITING_NOT_NULL_PROPS
          )
        ),
      };
    case LOADED_ALL_IDEBS_ACTION:
      return {
        ...state,
        allIdebs: action.payload,
      };
    case CHANGED_ESCOLA_EDITING_VALUE_ACTION:
      return {
        ...state,
        escolaEditing: {
          ...state.escolaEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case CLEARED_ESCOLA_ACTION:
      return { ...state, escolaEditing: ESCOLA_EDITING_INITIAL_STATE };
    case CLEARED_IDEB_ACTION:
      return { ...state, idebEditing: IDEB_EDITING_INITIAL_STATE };
    case LOADED_ESCOLA_ACTION:
      return {
        ...state,
        escolaEditing: {
          ...transformNullIntoEmpty(
            action.payload,
            ESCOLA_EDITING_NOT_NULL_PROPS
          ),
          tipoInstituicao:
            action.payload.tipoInstituicao == null
              ? ''
              : action.payload.tipoInstituicao,
        },
      };
    case LOADED_ALL_ESCOLAS_BY_LIST_CIDADE_ID:
      return {
        ...state,
        escolasPorCidade: action.payload,
        escolasByCidadesList: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case SET_CURRENT_TAB:
      return { ...state, currentTab: action.payload };
    case OPEN_MODAL:
      return { ...state, isOpen: true, modalContent: action.payload };
    case CLOSE_MODAL:
      return { ...state, isOpen: false, modalContent: null };
    case LOADING_MODALIDADES_ACTION:
      return {
        ...state,
        loadingModalidades: action.payload,
      };
    case LOADED_MODALIDADES_ACTION:
      return {
        ...state,
        modalidades: action.payload,
      };
    case LOADED_PROGRAMAS_ACTION:
      return {
        ...state,
        programas: action.payload,
      };

    case RESET_PROGRAMA_VALUE:
      return {
        ...state,
        programas: defaultProgramas,
      };
    case LOADED_PROGRAMA_INFO_ACTION:
      return {
        ...state,
        programas: {
          ...state.programas,
          ...action.payload,
        },
      };
    case LOADING_PROGRAMAS_ACTION:
      return {
        ...state,
        loadingProgramas: action.payload,
      };
    case UPDATE_PROGRAMA_VALUE:
      return {
        ...state,
        programas: {
          ...state.programas,
          [action.payload.tipo]: {
            ...state.programas[action.payload.tipo],
            ...action.payload.value,
          },
        },
      };
    case SUBMIT_COOP_DATA_SUCCESS:
      return {
        ...state,
        coopData: action.payload,
        error: null,
      };
    case SUBMIT_COOP_DATA_FAILURE:
      return {
        ...state,
        coopData: null,
        error: action.payload,
      };
    case LOADED_COOPS_ESCOLAR_ACTION:
      return {
        ...state,
        coopsEscolar: action.payload,
      };
    case LOADED_TIPO_DOCUMENTO_ACTION:
      return {
        ...state,
        tipoDocumentoCoop: action.payload,
      };
    case SAVING_COOP_ESCOLAR:
      return {
        ...state,
        savingCoops: action.payload,
      };
    case SET_CURRENT_TAB_PROGRAMA:
      return {
        ...state,
        programaTabCurrent: action.payload,
      };

    default:
      return state;
  }
}
